<template>
  <div class="envelope-template-signature-tags">
    <p class="text-text-primary text--large text--bold">
      {{ $t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSignatureTags.title') }}
    </p>
    <p class="text-text-secondary mb-8 text--small">
      {{ $t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSignatureTags.subTitle') }}
    </p>

    <PrepareSignatureTemplate
      v-if="envelopeTemplateToPrepare"
      :key="envelopeTemplateToPrepare.id"
      :envelope-to-prepare="envelopeTemplateToPrepare"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import PrepareSignatureTemplate from '@/project/signing-checklist/prepare-signature/PrepareSignatureTemplate.vue'
import type { EnvelopeTemplateToPrepare } from '@/project/views/EnvelopeTemplateAdd.vue'

export default defineComponent({
  name: 'EnvelopeTemplateAddSignatureTags',
  components: { PrepareSignatureTemplate },
  props: {
    envelopeTemplateToPrepare: {
      type: Object as PropType<EnvelopeTemplateToPrepare>,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.envelope-template-signature-tags {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
</style>
